import { Plugin } from "slate-react";
import _ from "underscore";

import { Blockquote } from "./blockquote";
import { Bold } from "./bold";
import { Heading1, Heading2, Heading3 } from "./headings";
import { Image } from "./image";
import { Italic } from "./italic";
import { Link } from "./link";
import { Paragraph } from "./paragraph";
import { Underline } from "./underline";

const EditorPlugins: Plugin[] = [
  ...Bold,
  ...Italic,
  ...Underline,
  ...Paragraph,
  ...Blockquote,
  ...Heading1,
  ...Heading2,
  ...Heading3,
  ...Link,
  ...Image,
];

export default EditorPlugins;
